import React, { useState } from 'react';
import {
  StyleSheet,
  Text,
  TextInput,
  View,
  TouchableOpacity,
  ImageBackground,
  Linking
} from "react-native";

import { COLORS, SIZES, IMAGES, FONTS } from '../constants';
import { useNavigation } from '@react-navigation/native';
import { MaterialIcons } from '@expo/vector-icons';

export default function BMIScreen() {

  const navigation = useNavigation();

  const [height, setHeight] = useState("");
  const [mass, setMass] = useState("");

  return (

    <ImageBackground
      source={IMAGES.bg2}
      style={styles.bg}
    >

      <View style={styles.container}>
        <View style={styles.header}>
          <View style={styles.headerLeft}>
            <Text style={styles.subtitleText} >
              Wskaźnik masy ciała</Text>
          </View>

          <TouchableOpacity
            onPress={() => { Linking.openURL('https://pl.wikipedia.org/wiki/Wska%C5%BAnik_masy_cia%C5%82a') }}
          >

            <View style={styles.headerRight}>
              <View style={styles.outlineBtn}>
                <Text style={styles.outlineBtnText}>
                  wiki
                </Text>
              </View>
            </View>
          </TouchableOpacity>
        </View>

        {/* <View style={styles.intro}> */}
        <TextInput
          value={height}
          placeholder="Wzrost [cm]"
          name="fHeight"
          placeholderTextColor={COLORS.secondary}
          // keyboardType="decimal-pad"
          keyboardType="numeric"
          style={styles.input}
          onChangeText={text => {
            setHeight(text)
            // setState({ [state.resultNumber]: text })
          }
          }
        />
        <TextInput
          value={mass}
          placeholder="Waga [kg]"
          name="fMass"
          placeholderTextColor={COLORS.secondary}
          keyboardType="numeric"
          style={styles.input}
          onChangeText={text => {
            setMass(text)
          }}
        />
        {/* </View> */}

        <TouchableOpacity
          style={styles.button}
          onPress={() => {
            navigation.navigate('BMIResult', {
              heightKey: height,
              massKey: mass
            });
          }}
        >
          <ImageBackground
            source={IMAGES.arrowBtnBg}
            style={styles.arrowBtnBg}
          >
            <View style={styles.arrowBtn}>
              <MaterialIcons name="arrow-forward" size={48} color={COLORS.primary} />
            </View>
          </ImageBackground>
        </TouchableOpacity>
      </View>
    </ImageBackground>
  );
}

const styles = StyleSheet.create({
  container: {
    // alignItems: 'center',
    // justifyContent: 'center',
    // padding: Platform.OS === "ios" ? 40 : StatusBar.currentHeight + 10,
    flex: 1,
    padding: SIZES.padding,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignContent: 'space-around',
    alignItems: 'flex-start',
  },
  headerLeft: {
    // width: '60%',
    paddingTop: 0
  },
  headerRight: {
    paddingTop: 0
  },
  titleText: {
    ...FONTS.title
  },
  subtitleText: {
    ...FONTS.subtitle
  },
  outlineBtn: {
    backgroundColor: COLORS.background,
    borderColor: COLORS.secondary,
    borderRadius: 5,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: 80,
    height: 30,
  },
  outlineBtnText: {
    color: COLORS.primary,
    fontSize: 12
  },
  bg: {
    width: "100%",
    height: "100%"
  },
  intro: {
    flexDirection: "row",
    marginBottom: 20
  },
  inputRow: {
    flexDirection: "row",
    height: 60,
    marginTop: 15,
    marginBottom: 15,
  },
  input: {
    borderColor: COLORS.secondary,
    backgroundColor: COLORS.background,
    borderWidth: 1,
    borderRadius: 10,
    padding: 15,
    margin: 15,
    textAlign: "center",
    height: "30%",
    width: "100%",
    fontSize: 45,
    marginTop: 24,
    color: COLORS.accent
  },
  arrowBtn: {
    width: 80,
    height: 80,
    marginRight: 20,
    borderRadius: 50,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.background
  },
  arrowBtnBg: {
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    position: 'absolute',
    right: 0,
    bottom: 20,
    width: 122,
    height: 100,
    resizeMode: 'cover',
  },
  buttonText: {
    alignSelf: "center",
    padding: 30,
    fontSize: 25,
    color: "#FFCB1F",
    fontWeight: "bold"
  },
  result: {
    alignSelf: "center",
    color: COLORS.accent,
    fontSize: 35,
    padding: 15
  },
  infoTxt: {
    alignSelf: "center",
    color: COLORS.primary,
    fontSize: 25,
    paddingTop: 35
  }
});